import { StackedCardCarousel, IStackedCardCarouselProps, RollingCardCarousel, IRollingCardCarouselProps } from './variants';

export const Carousel = {
    StackedCard: StackedCardCarousel,
    RollingCard: RollingCardCarousel
};

export type { IStackedCardCarouselProps, IRollingCardCarouselProps };

export { Item } from './common/carousel-item';
export type { IItemProps } from './common/carousel-item';
